// Quiz "Scopri il potenziale della tua struttura" — Home Staging
// Struttura di scoring & routing (i testi restano quelli forniti).
// option: { key, text, points, flag?: 'CALL', urgency?: 'alta'|'media'|'bassa' }

export const MAX_SCORE = 10; // domande 1-5 (la 6 non conta)

export const QUIZ_QUESTIONS = [
  {
    id: 1,
    question:
      'Quando senti parlare di "Home Staging", a cosa pensi istintivamente?',
    options: [
      {
        key: "a",
        text: "A qualcuno che viene a sistemare i mobili e mettere due cuscini per fare le foto.",
        points: 0,
      },
      {
        key: "b",
        text: "A un intervento costoso di ristrutturazione o cambio arredamento.",
        points: 0,
      },
      {
        key: "c",
        text: "A una tecnica di marketing strategico per aumentare il valore percepito e le prenotazioni.",
        points: 2,
      },
      {
        key: "d",
        text: "Non ne ho idea, sono qui proprio per capire!",
        points: 0,
        flag: "CALL",
      },
    ],
  },
  {
    id: 2,
    question:
      "Quando un potenziale ospite entra in casa tua, cosa nota per prima?",
    options: [
      { key: "a", text: "Lo spazio e la luce (nulla di anonimo).", points: 2 },
      {
        key: "b",
        text: "I miei oggetti personali (foto, ricordi, trofei).",
        points: 0,
      },
      {
        key: "c",
        text: "Qualche mobile un po' datato o disordine in giro.",
        points: 0,
        flag: "CALL",
      },
    ],
  },
  {
    id: 3,
    question: 'Hai già fatto un "decluttering" (rimozione del superfluo)?',
    options: [
      {
        key: "a",
        text: "Sì, ho rimosso tutto quello che non serve per far respirare gli spazi.",
        points: 2,
      },
      {
        key: "b",
        text: "No, ma ho messo tutto negli scatoloni negli armadi.",
        points: 0,
      },
      { key: "c", text: "No, la casa è vissuta come sempre.", points: 0 },
    ],
  },
  {
    id: 4,
    question:
      "Le tue foto online sono state fatte da un professionista o col telefono?",
    options: [
      {
        key: "a",
        text: "Foto professionali che valorizzano gli spazi.",
        points: 2,
      },
      { key: "b", text: "Foto col cellulare, ma con molta cura.", points: 0 },
      {
        key: "c",
        text: "Foto rapide fatte dal proprietario o dall'agenzia.",
        points: 0,
      },
    ],
  },
  {
    id: 5,
    question:
      "Come appare il tuo annuncio sui portali (Airbnb/Booking) rispetto ai vicini?",
    options: [
      {
        key: "a",
        text: 'Le mie foto sono più accattivanti e si nota subito un "tocco" professionale.',
        points: 2,
      },
      {
        key: "b",
        text: "Sono nella media, ma potrei migliorare la presentazione.",
        points: 1,
      },
      {
        key: "c",
        text: "Temo che le foto non rendano giustizia alla bellezza della casa.",
        points: 0,
      },
    ],
  },
  {
    id: 6,
    // Non dà punteggio — misura l'urgenza
    question:
      "Qual è il tuo livello di urgenza nel migliorare le performance della struttura?",
    options: [
      {
        key: "a",
        text: "Massima: voglio vedere risultati entro la prossima stagione.",
        points: 0,
        urgency: "alta",
      },
      {
        key: "b",
        text: "Media: sto valutando cambiamenti per l'anno prossimo.",
        points: 0,
        urgency: "media",
      },
      { key: "c", text: "Bassa: sono solo curioso.", points: 0, urgency: "bassa" },
    ],
  },
];

// URL reali del sito
const SITE = "https://francescaspinazzola.it";
export const LINKS = {
  contatti: `${SITE}/#contatti`,
  portfolio: `${SITE}/portfolio`,
  serviziExtra: `${SITE}/servizi-extra`,
  serviziPrivati: `${SITE}/servizi-privati`,
  percorsi: `${SITE}/percorsi-affiancamento`,
};

// Calcola il risultato secondo le regole di routing (in ordine di priorità)
export function computeResult(answers) {
  let score = 0;
  let flagCall = false;
  let urgenza = "media";

  QUIZ_QUESTIONS.forEach((q) => {
    const key = answers[q.id];
    if (!key) return;
    const opt = q.options.find((o) => o.key === key);
    if (!opt) return;
    if (opt.flag === "CALL") flagCall = true;
    if (opt.urgency) urgenza = opt.urgency;
    if (typeof opt.points === "number") score += opt.points;
  });

  const perc = Math.round((score / MAX_SCORE) * 100);

  // Regola 1 — FLAG_CALL (priorità assoluta)
  if (flagCall) {
    return { rule: "call", urgenza, score, perc, ...RESULTS.call };
  }
  // Regola 2 — alto (>= 70%)
  if (perc >= 70) {
    return { rule: "alto", urgenza, score, perc, ...RESULTS.alto };
  }
  // Regola 3 — medio (40-69%)
  if (perc >= 40) {
    return { rule: "medio", urgenza, score, perc, ...RESULTS.medio };
  }
  // Regola 4 — basso (< 40%)
  return { rule: "basso", urgenza, score, perc, ...RESULTS.basso };
}

export const RESULTS = {
  call: {
    title: "Parliamone insieme",
    text: [
      "Hai già alzato la mano dicendo che preferisci parlarne, ed è la scelta migliore. Il primo passo è una chiacchierata conoscitiva gratuita: ascolto la tua storia, guardiamo insieme la tua struttura e capiamo la strada giusta, senza formule preconfezionate.",
    ],
    ctas: [
      { label: "Prenota la tua call gratuita", href: LINKS.contatti, primary: true },
      { label: "Guarda i miei lavori", href: LINKS.portfolio },
    ],
  },
  alto: {
    title: "Sei preparato. Ora fatti aiutare a fare il salto.",
    text: [
      "Conosci bene il mondo dell'home staging: sai cosa serve e perché funziona. Per chi è già a questo livello, il passo giusto non è un corso base, è vedere cosa posso fare per la tua struttura e scegliere il servizio su misura.",
    ],
    ctas: [
      { label: "Scopri i servizi", href: LINKS.serviziExtra, primary: true },
      { label: "Servizi privati", href: LINKS.serviziPrivati },
      { label: "Percorsi di affiancamento", href: LINKS.percorsi },
      { label: "Guarda i miei lavori", href: LINKS.portfolio },
    ],
  },
  medio: {
    title: "Buone basi. Con un affiancamento diventano risultati.",
    text: [
      "Hai già capito parecchio, ma su alcuni punti rischi di perdere tempo (e resa) andando per tentativi. Il percorso di affiancamento serve esattamente a questo: partire da dove sei e arrivare a una struttura che si vende da sola.",
    ],
    ctas: [
      { label: "Scopri il percorso di affiancamento", href: LINKS.percorsi, primary: true },
      { label: "Prenota una call", href: LINKS.contatti },
    ],
  },
  basso: {
    title: "Partiamo dalle basi, insieme.",
    text: [
      "Sei all'inizio del percorso, ed è il momento perfetto per farlo bene. La cosa più utile ora non è una pagina piena di servizi, ma una conversazione diretta e vedere risultati concreti: da lì costruiamo la strategia giusta per la tua struttura.",
    ],
    ctas: [
      { label: "Prenota la tua call gratuita", href: LINKS.contatti, primary: true },
      { label: "Guarda i miei lavori", href: LINKS.portfolio },
    ],
  },
};

// Riga extra in base all'urgenza (modula il testo, non il routing)
export const URGENCY_NOTE = {
  alta: "Visto che vuoi aprire a breve, muoviti ora: le prime impressioni non si rifanno.",
  media: null,
  bassa: null,
};
